import { useState, useEffect } from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { Toaster, toast} from 'react-hot-toast';
import { GETCATEGORIESLIST, UPDATE_CATEGORY } from "../../api/apiConfig";
import { apiGet, apiPost } from "../../utils/services";

const DispatchTimePicker = ({days, onSelectTimer}) => {
  return (
    <div className="dispatch-time-picker">
      <button className="btn-picker" 
        onClick={() => onSelectTimer("1")}
        aria-selected={days === "1" ? "true" : "false"}>1</button>
      <button className="btn-picker" 
        onClick={() => onSelectTimer("2")}
        aria-selected={days === "2" ? "true" : "false"} >2</button>
      <button className="btn-picker" 
          onClick={() => onSelectTimer("3")}
          aria-selected={days === "3" ? "true" : "false"}>3</button>
      <button className="btn-picker" 
        onClick={() => onSelectTimer("4")}
        aria-selected={days === "4" ? "true" : "false"}>4</button>
      <button className="btn-picker" 
        onClick={() => onSelectTimer("5")}
        aria-selected={days === "5" ? "true" : "false"}>5</button>
      <button className="btn-picker" 
        onClick={() => onSelectTimer("6")}
        aria-selected={days === "6" ? "true" : "false"}>6</button>
      <button className="btn-picker" 
        onClick={() => onSelectTimer("7")}
        aria-selected={days === "7" ? "true" : "false"}>7+</button>
    </div>    
  )
}

const updateCategoryApi = (payload) => {
  return apiPost(UPDATE_CATEGORY, payload);
}

const DispatchTimer = () => {
  const [categoryList, setCategoryList] = useState([]);

  useEffect(() => {
    async function populateCategories() { 
      const res = await apiGet(GETCATEGORIESLIST);
      if(res) {
        const { data } = res;
        setCategoryList(data);
      }
    }
    populateCategories();
  }, []);

  async function handleDispatchTimerClick({category, days}) {
    setCategoryList(categoryList.map(categoryItem => {
      if(categoryItem.id === category.id) {
        return {...category, dispatchDays: days} 
      }
      return categoryItem;
    }));

    toast.promise(
      updateCategoryApi({id: category.id, name: category.name, dispatchDays: parseInt(days)}),
       {
         loading: 'Saving...',
         success: <b>Dispatch Time Saved!</b>,
         error: <b>Could not save.</b>,
       }
     );
  } 

  return (
    <div className="tabPanelCls h-100" >
      <Toaster/>
      <div className="dispatchTimer" style={{position:'relative'}}>
        <div style={{position:'fixed',width:'100%',background:'white',marginTop:'10px'}}>
        <div className="header">
          <h2>Dispatch Timer</h2>
        </div>
        <div className="description mt-1">
          <p className="sm" style={{width:'95%'}}>
            Please set an expected dispatch time for each product category, this will be displayed to the customer on each product page.
            This is shown to the customer before they place an order, to set  their expectations.
          </p>
          <div className="example">
            {/* <div className="title-container">
              <span className="fs-5">Example Product: </span>
              <span className="fs-5 fw-bold">Cricket Bat</span>
            </div>  */}
            <div className="d-flex flex-column w-100 mb-3 mt-3"> 
              <div className="d-flex justify-content-between w-100 center ">
                  <span className="value sm">(You manage)</span>
                  <div></div>
                  <span className="value">(The Cricket Store manages)</span>
                  <div></div>
                  <span className="value d-inline-block">(What customer sees)</span>
              </div>
              <div className="d-flex justify-content-between w-100">
                <span className="fs-6 fw-bold text-center w-100">Bat Product Time</span>
                <div></div>
                <span className="fs-6 fw-bold  text-center w-100">Delivery Time</span>
                <div></div>
                  <span className="fs-6 fw-bold  text-center w-100">E2E Delivery Time</span>
              </div>
              <div className="d-flex justify-content-around w-100 fw-bold ">
                <span className="w-100 text-center">7 Days</span> 
                <span style={{marginTop:'-20px'}}>+</span> 
                <span className="w-100 text-center">2 Days</span> 
                <span style={{marginTop:'-20px'}}>=</span> 
                <span className="w-100 text-center">9 Days</span> 
              </div>
            </div>
          </div>
        </div>
        <Tabs defaultIndex={0} className="mt-3 h-100 w-100 overflow-hidden d-sm-none">
          <TabList>
            {categoryList.map((category) => {
                return (
                  <Tab key={category.id}>
                    {category.name}
                  </Tab>
                );
              })}
          </TabList>
          {categoryList.map((category, index) => {
              return (
                <TabPanel index={index} key={category.id}>
                  <div className="d-flex flex-column justify-content-center align-items-center text-center h-100 px-1" style={{marginBottom: "50px"}}>
                    <p style={{marginTop: "80px", marginBottom: "80px"}}>Please select how many days it will take before you dispatch each product.</p>
                    <DispatchTimePicker 
                      days={category.dispatchDays} onSelectTimer={(days) => {
                      handleDispatchTimerClick({category, days});
                    }}/>
                </div>
                </TabPanel>
              );
            })}
        </Tabs>
      </div>
      <ul className="category-list d-none d-sm-block" style={{marginTop:'200px'}}> 
          {categoryList.map(category => {
            return (
              <li key={category.id}>
                <h3>{category.name}</h3>
                <DispatchTimePicker days={category.dispatchDays} onSelectTimer={(days) => {
                  handleDispatchTimerClick({category, days});
                }}/>
              </li> 
            )
          })}
        </ul>
      
      </div>
    </div>
  )
}

export default DispatchTimer;
